module.exports = __webpack_public_path__ + "img/Freek_01.dc92d3a3.jpg";